import { render, staticRenderFns } from "./FormDateInput.vue?vue&type=template&id=67cc00d8&"
import script from "./FormDateInput.vue?vue&type=script&lang=js&"
export * from "./FormDateInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports